import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import DeleteAccount from "pages/DeleteAccount";
import { Layout } from "components/layout";
import LoginPage from "pages/auth/LoginPage";
import Media from "react-media";
import RequireAuth from "pages/auth/RequireAuth";

function App() {
  return (
    <Media query="(max-width: 768px)">
      {(matches) => (
        <Routes>
          <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route path="/delete-user" element={<DeleteAccount />} />

              {/* Redirect all routes to the delete-user page */}
            </Route>
            <Route path="/*" element={<Navigate to="/delete-user" replace />} />
          </Route>

          {/* Public routes */}
          <Route path="/login" element={<LoginPage />}>
            <Route path="/login/:tokenId" element={<Outlet />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Media>
  );
}

export default App;
